import React from 'react';
import { Card, Col } from 'react-bootstrap';

/* get the return vali & distructuring */
const Course = (props) => {
    const { name, fee, instructor, img, details } = props.course;


    return (
        <div >
            {/* Show the couses card */}
            <Col className="h-100">
                <Card className="h-100">
                    <Card.Img variant="top" src={img} />
                    <Card.Body>
                        <Card.Title>{name}</Card.Title>
                        <Card.Text>By: {instructor}</Card.Text>
                        <Card.Text>Course Fee: {fee}</Card.Text>
                        <Card.Text>
                            {
                                details
                            }
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>

        </div>
    );
};

export default Course;